<template>
  <div class="vld-parent" ref="rootElement">
    <div>
      <div class="card">
        <div class="card-header">Patient Analytics</div>
        <div class="card-body">
          <div class="selection">
            <div class="filter">
              <label class="col-form-label label" for="date">Date</label>
              <input class="form-control form-control-sm" id="date" type="text" ref="dateInput" />
            </div>
            <div class="filter">
              <button
                type="button"
                class="btn btn-sm btn-blue btn-100"
                v-on:click="fetchData();"
                ref="refreshButton"
              >Refresh</button>
            </div>
          </div>

          <div class="chart-section" v-if="patientCountDataLoaded">
            <h5>
              Patient count [
              <b>{{ totalPatientCount }}</b> ]
            </h5>
            <LineChart :chartdata="patientCountLineChartDatasets" />
          </div>

          <div class="chart-section" v-if="patientCountDataLoaded">
            <h5>Patient count by gender</h5>
            <div class="chart-container">
              <LineChart :chartdata="patientGenderCountLineChartDatasets" class="line-chart" />
              <PieChart :chartdata="patientGenderCountPieChartData" class="pie-chart" />
            </div>
          </div>

          <div class="chart-section" v-if="patientCountDataLoaded">
            <h5>Patient count by title</h5>
            <div class="chart-container">
              <LineChart :chartdata="patientTitleCountLineChartDatasets" class="line-chart" />
              <PieChart :chartdata="patientTitleCountPieChartData" class="pie-chart" />
            </div>
          </div>

          <div class="chart-section" v-if="patientCountDataLoaded">
            <h5>
              Patient count by collection center [
              <b>{{ totalPatientCountByCollectionCenter }}</b>
              ( {{ (totalPatientCountByCollectionCenter * 100.0 / totalPatientCount).toFixed(2) }} % of total patient count ) ]
            </h5>
            <div class="chart-container">
              <LineChart
                :chartdata="patientCollectionCenterCountLineChartDatasets"
                class="line-chart"
              />
              <PieChart :chartdata="patientCollectionCenterCountPieChartData" class="pie-chart" />
            </div>
          </div>

          <div class="chart-section" v-if="patientCountDataLoaded">
            <h5>
              Patient count by requested by [
              <b>{{ totalPatientCountByRequestedBy }}</b>
              ( {{ (totalPatientCountByRequestedBy * 100.0 / totalPatientCount).toFixed(2) }} % of total patient count ) ]
            </h5>
            <div class="chart-container">
              <LineChart :chartdata="patientRequestedByCountLineChartDatasets" class="line-chart" />
              <PieChart :chartdata="patientRequestedByCountPieChartData" class="pie-chart" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Utils from "@/utils.js";
import moment from "moment";
import { EventBus } from "@/global-event-bus.js";
// import { EVENT_ANALYTIC_DATE_RANGE, DATE_FROM, DATE_TO } from '@/event-constants.js'
import LineChart from "@/components/LineChart.vue";
import PieChart from "@/components/PieChart.vue";
import $ from "jquery";
var randomColor = require("randomcolor");

import daterangepicker from "daterangepicker";
require("daterangepicker/daterangepicker.css");

export default {
  name: "Analytic",

  components: {
    LineChart,
    PieChart
  },

  data() {
    return {
      dateSelection: [moment(), moment()],
      totalPatientCount: 0,
      totalPatientCountByCollectionCenter: 0,
      totalPatientCountByRequestedBy: 0,
      patientCountLineChartDatasets: [],
      patientTitleCountLineChartDatasets: [],
      patientTitleCountPieChartData: {},
      patientGenderCountLineChartDatasets: [],
      patientGenderCountPieChartData: {},
      patientCollectionCenterCountLineChartDatasets: [],
      patientCollectionCenterCountPieChartData: {},
      patientRequestedByCountLineChartDatasets: [],
      patientRequestedByCountPieChartData: {},
      patientCountDataLoaded: false,
      componentRefsToDisableAtBusy: ["dateInput", "refreshButton"]
    };
  },

  mounted() {
    var self = this;

    $("#date").daterangepicker(Utils.getDateRangePickerOptions(), function(
      start,
      end,
      label
    ) {
      self.dateSelection[0] = start;
      self.dateSelection[1] = end;

      self.fetchData();
    });

    this.fetchData();
  },

  created() {},

  beforeDestroy() {},

  methods: {
    fetchData: function() {
      if (this.dateSelection == null) {
        return;
      }

      var dateFrom = this.dateSelection[0].clone();
      var dateFromTimestamp = dateFrom
        .startOf("day")
        .utc()
        .valueOf();
      var dateTo = this.dateSelection[1].clone();
      var dateToTimestamp = dateTo
        .endOf("day")
        .utc()
        .valueOf();

      // fetch data
      const loading = Utils.busy(this, true, this.componentRefsToDisableAtBusy);

      this.patientCountDataLoaded = false;

      var utcOffset = moment().utcOffset();

      axios
        .get(Utils.getURL("/analytic/getPatientAnalytics"), {
          params: {
            dateFrom: dateFromTimestamp,
            dateTo: dateToTimestamp,
            utcOffset: utcOffset
          }
        })
        .then(response => {
          Utils.unbusy(this, loading, true, this.componentRefsToDisableAtBusy);

          var totalPatientCount = 0;
          var totalPatientCountByCollectionCenter = 0;
          var totalPatientCountByRequestedBy = 0;

          var data = response.data.results.data;

          var patientCountChartData = [];
          var patientTitleToChartData = {};
          var patientGenderToChartData = {};
          var patientCollectionCenterToChartData = {};
          var patientRequestedByToChartData = {};

          var patientTitleToTotalCount = {};
          var patientGenderToTotalCount = {};
          var patientCollectionCenterToTotalCount = {};
          var patientRequestedByToTotalCount = {};

          Object.keys(data).forEach(date => {
            var dateDataObject = data[date];

            patientCountChartData.push({
              x: date,
              y: dateDataObject.count
            });

            totalPatientCount += dateDataObject.count;

            // patient title count
            if (dateDataObject.title) {
              Object.keys(dateDataObject.title).forEach(title => {
                if (!Object.keys(patientTitleToChartData).includes(title)) {
                  patientTitleToChartData[title] = [];
                }

                patientTitleToChartData[title].push({
                  x: date,
                  y: dateDataObject.title[title]
                });

                if (!Object.keys(patientTitleToTotalCount).includes(title)) {
                  patientTitleToTotalCount[title] = 0;
                }
                patientTitleToTotalCount[title] += dateDataObject.title[title];
              });
            }

            // patient gender count
            if (dateDataObject.gender) {
              Object.keys(dateDataObject.gender).forEach(gender => {
                if (!Object.keys(patientGenderToChartData).includes(gender)) {
                  patientGenderToChartData[gender] = [];
                }

                patientGenderToChartData[gender].push({
                  x: date,
                  y: dateDataObject.gender[gender]
                });

                if (!Object.keys(patientGenderToTotalCount).includes(gender)) {
                  patientGenderToTotalCount[gender] = 0;
                }
                patientGenderToTotalCount[gender] +=
                  dateDataObject.gender[gender];
              });
            }

            // patient collection center count
            if (dateDataObject.collectionCenter) {
              Object.keys(dateDataObject.collectionCenter).forEach(
                collectionCenter => {
                  if (
                    !Object.keys(patientCollectionCenterToChartData).includes(
                      collectionCenter
                    )
                  ) {
                    patientCollectionCenterToChartData[collectionCenter] = [];
                  }

                  patientCollectionCenterToChartData[collectionCenter].push({
                    x: date,
                    y: dateDataObject.collectionCenter[collectionCenter]
                  });

                  totalPatientCountByCollectionCenter +=
                    dateDataObject.collectionCenter[collectionCenter];

                  if (
                    !Object.keys(patientCollectionCenterToTotalCount).includes(
                      collectionCenter
                    )
                  ) {
                    patientCollectionCenterToTotalCount[collectionCenter] = 0;
                  }
                  patientCollectionCenterToTotalCount[collectionCenter] +=
                    dateDataObject.collectionCenter[collectionCenter];
                }
              );
            }

            // patient requested by count
            if (dateDataObject.requestedBy) {
              Object.keys(dateDataObject.requestedBy).forEach(requestedBy => {
                if (
                  !Object.keys(patientRequestedByToChartData).includes(
                    requestedBy
                  )
                ) {
                  patientRequestedByToChartData[requestedBy] = [];
                }

                patientRequestedByToChartData[requestedBy].push({
                  x: date,
                  y: dateDataObject.requestedBy[requestedBy]
                });

                totalPatientCountByRequestedBy +=
                  dateDataObject.requestedBy[requestedBy];

                if (
                  !Object.keys(patientRequestedByToTotalCount).includes(
                    requestedBy
                  )
                ) {
                  patientRequestedByToTotalCount[requestedBy] = 0;
                }
                patientRequestedByToTotalCount[requestedBy] +=
                  dateDataObject.requestedBy[requestedBy];
              });
            }
          });

          this.totalPatientCount = totalPatientCount;
          this.totalPatientCountByCollectionCenter = totalPatientCountByCollectionCenter;
          this.totalPatientCountByRequestedBy = totalPatientCountByRequestedBy;

          this.patientCountDataLoaded = true;

          var colors = this.getRandomColors(1);
          this.patientCountLineChartDatasets = {
            datasets: [
              {
                label: "Patient Count",
                backgroundColor: colors[0],
                borderColor: colors[0],
                data: patientCountChartData,
                fill: false
              }
            ]
          };

          // patient title count datasets
          var patientTitleCountCD = []; // CD stands for chart dataset
          var colors = this.getRandomColors(
            Object.keys(patientTitleToChartData).length
          );
          Object.keys(patientTitleToChartData).forEach((title, index) => {
            patientTitleCountCD.push({
              label: title,
              backgroundColor: colors[index],
              borderColor: colors[index],
              data: patientTitleToChartData[title],
              fill: false
            });
          });

          this.patientTitleCountLineChartDatasets = {
            datasets: patientTitleCountCD
          };

          // patient title count pie chart dataset
          this.patientTitleCountPieChartData = {
            labels: Object.keys(patientTitleToTotalCount),
            datasets: [
              {
                data: Object.values(patientTitleToTotalCount),
                backgroundColor: colors
              }
            ]
          };

          // patient gender count datasets
          var patientGenderCountCD = []; // CD stands for chart dataset
          var colors = this.getRandomColors(
            Object.keys(patientGenderToChartData).length
          );
          Object.keys(patientGenderToChartData).forEach((gender, index) => {
            patientGenderCountCD.push({
              label: gender,
              backgroundColor: colors[index],
              borderColor: colors[index],
              data: patientGenderToChartData[gender],
              fill: false
            });
          });

          this.patientGenderCountLineChartDatasets = {
            datasets: patientGenderCountCD
          };

          // patient gender count pie chart dataset
          this.patientGenderCountPieChartData = {
            labels: Object.keys(patientGenderToTotalCount),
            datasets: [
              {
                data: Object.values(patientGenderToTotalCount),
                backgroundColor: colors
              }
            ]
          };

          // patient collection center count datasets
          var patientCollectionCenterCountCD = []; // CD stands for chart dataset
          var colors = this.getRandomColors(
            Object.keys(patientCollectionCenterToChartData).length
          );
          Object.keys(patientCollectionCenterToChartData).forEach(
            (collectionCenter, index) => {
              patientCollectionCenterCountCD.push({
                label: collectionCenter,
                backgroundColor: colors[index],
                borderColor: colors[index],
                data: patientCollectionCenterToChartData[collectionCenter],
                fill: false
              });
            }
          );

          this.patientCollectionCenterCountLineChartDatasets = {
            datasets: patientCollectionCenterCountCD
          };

          // patient collection center count pie chart dataset
          this.patientCollectionCenterCountPieChartData = {
            labels: Object.keys(patientCollectionCenterToTotalCount),
            datasets: [
              {
                data: Object.values(patientCollectionCenterToTotalCount),
                backgroundColor: colors
              }
            ]
          };

          // patient requested by count datasets
          var patientRequestedByCountCD = []; // CD stands for chart dataset
          var colors = this.getRandomColors(
            Object.keys(patientRequestedByToChartData).length
          );
          Object.keys(patientRequestedByToChartData).forEach(
            (requestedBy, index) => {
              patientRequestedByCountCD.push({
                label: requestedBy,
                backgroundColor: colors[index],
                borderColor: colors[index],
                data: patientRequestedByToChartData[requestedBy],
                fill: false
              });
            }
          );

          this.patientRequestedByCountLineChartDatasets = {
            datasets: patientRequestedByCountCD
          };

          // patient requested by count pie chart dataset
          this.patientRequestedByCountPieChartData = {
            labels: Object.keys(patientRequestedByToTotalCount),
            datasets: [
              {
                data: Object.values(patientRequestedByToTotalCount),
                backgroundColor: colors
              }
            ]
          };
        })
        .catch(error => {
          Utils.unbusy(this, loading, true, this.componentRefsToDisableAtBusy);
          Utils.notifyError(error);
        });
    },

    getRandomColors(number) {
      return randomColor({
        count: number,
        luminosity: "bright"
      });
    }
  },

  computed: {},

  watch: {}
};
</script>

<style scoped>
.selection {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.filter {
  display: flex;
  justify-content: space-between;
}

.chart-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.line-chart {
  width: 80%;
  display: flex;
  flex-wrap: wrap;
}

.pie-chart {
  width: 20%;
  display: flex;
  flex-wrap: wrap;
}

.chart-section {
  margin-top: 25px;
}
</style>
